module.exports = __webpack_public_path__ + "img/badge-list-thumb-090.58d35927.png";